// extracted by mini-css-extract-plugin
export default {"user-select":"MHAS","userSelect":"MHAS"};